import {CreateSurveyFormValues} from '../survey-form';

export const formHasFirstQuestionAndAnswer = (values: CreateSurveyFormValues) =>
    !!(
        values?.sections?.[0]?.questions?.[0]?.name &&
        values?.sections?.[0]?.questions?.[0]?.answers?.[0]?.name
    );
